<template>
    <div class="full-cut-detail-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{form.fullCutName || '新建'}}</h2>
        </div>
        <el-tabs type="border-card" tab-position="top" @tab-click="handleClick" v-model="tabSel">
            <el-tab-pane label="满减管理" name="tab0">
                <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
                    <el-button size="small" type="danger" @click="updateOrAdd">{{fullcutId == 0 ? '下一步' : '保 存'}}
                    </el-button>
                </div>
                <el-form :model="form" label-width="120px" size="small">
                    <el-form-item label="名称" :required="true">
                        <el-input v-model="form.fullCutName" placeholder="名称" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="开始日期" :required="true">
                        <el-date-picker
                                v-model="form.beginTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" :required="true">
                        <el-date-picker
                                v-model="form.endTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="满减类型" :required="true">
                        <el-select v-model="form.type" @change="typeChange()" :disabled="globalFullCutDisabled">
                            <el-option
                                    v-for="item in typeList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="满减分类" :required="true">
                        <el-select v-model="form.fullClass" @change="fullClassChange()">
                            <el-option
                                    v-for="item in fullClassList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="满减条件" :required="true" v-show="form.type==1||form.type==2||form.type==4||form.type==5">
                        <el-input v-model="fullCutNumbersStr" placeholder="例：满几减几" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="" v-show="form.type==1||form.type==2||form.type==4||form.type==5">
                        满
                        <el-input-number v-model="form.fullNumber" :disabled="form.type==3" :min="1" :max="10000" label="满"></el-input-number>
                        {{cut_type_desc}}
                        <el-input-number v-model="form.cutNumber" :disabled="form.type==3" :min="0" :max="10000" :label="cut_type_desc"></el-input-number>
                        <span v-show="form.type==4||form.type==5">折</span>
                        <el-button @click="addFullCutNumbers" :disabled="form.type==3">添加</el-button>
                        <el-button @click="delFullCutNumbers" :disabled="form.type==3">删除</el-button>
                    </el-form-item>
                    <el-form-item label="满减规则" v-show="form.type==1" :required="true">
                        <el-select v-model="form.cutRule" @change="cutRuleChange()" >
                            <el-option
                                    v-for="item in ruleList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="指定商品" v-show="form.cutRule==4" :required="true">
                        <el-select v-model="form.productIdsForm" multiple >
                            <el-option
                                    v-for="item in getProductList"
                                    :key="item.proId"
                                    :label="item.proName"
                                    :value="item.proId">
                            </el-option>
                        </el-select>
                        满减规则是指定商品的时候选择
                    </el-form-item>
                    <el-form-item label="指定商品名称" v-show="form.cutRule==4" :required="true">
                        <el-input v-model="form.productNames" placeholder="指定商品名称" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="指定商品规则" v-show="form.cutRule==4" :required="true">
                        <el-select :popper-append-to-body="true" v-model="form.productRule">
                            <el-option
                                    v-for="item in productRuleList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        选择指定商品的时候选择  标示满减的商品是直接减掉还是赠送
                    </el-form-item>
                    <el-form-item label="规则名称" :required="true">
                        <el-input v-model="form.cutRuleName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="单用户限购数量/指定数量">
                        <el-input-number v-model="form.limitCount" :min="0" :max="10000" placeholder="满减规则为指定数量和金额时"></el-input-number>
                    </el-form-item>
                    <el-form-item label="指定金额" v-show="form.type==3">
                        <el-input-number v-model="form.fullAmout" :min="0" :max="9999"></el-input-number>
                    </el-form-item>
                    <el-form-item label="状态" :required="true">
                        <el-select :popper-append-to-body="true" v-model="form.status">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="叠加促销" :required="true">
                        <el-select :popper-append-to-body="true" v-model="form.doublePromotion">
                            <el-option
                                    v-for="item in statusList1"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="叠加赠品" :required="true">
                        <el-select :popper-append-to-body="true" v-model="form.doubleFreeGift">
                            <el-option
                                    v-for="item in statusList1"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <span style="color: red">选择否 下单无赠品(使用赠品券没有赠品)</span>
                    </el-form-item>
                    <el-form-item label="可用优惠券" :required="true">
                        <el-select :popper-append-to-body="true" v-model="form.enableUseCoupon">
                            <el-option
                                    v-for="item in statusList1"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否免邮费":required="true">
                        <el-select v-model="form.isFreeFreight"  placeholder="是否免邮费">
                            <el-option v-for="item in selArr"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select><span style="color: red">设置免邮后用户无需达到包邮金额即可免运费，请谨慎设置！！！</span>
                    </el-form-item>
                    <el-form-item label="页面提示信息" :required="true">
                        <el-input type="textarea" :rows="2" placeholder="页面提示信息" v-model="form.fullCutTitle"></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="产品管理" v-if="fullcutId!=0" name="tab1">
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="单品">
                        <el-select v-model="form1.productId" multiple filterable>
                            <el-option
                                    v-for="item in getProductList"
                                    :key="item.proId"
                                    :label="item.proName"
                                    :value="item.proId">
                            </el-option>
                        </el-select>
                        <el-button type="success" @click="handleAddProductGroup">添加产品</el-button>
                    </el-form-item>
<!--                    <el-form-item label="组合">-->
<!--                        <el-select v-model="form1.groupId" multiple filterable>-->
<!--                            <el-option-->
<!--                                    v-for="item in getGroupList"-->
<!--                                    :key="item.id"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.id">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                        <el-button type="success" @click="handleAddProductGroup">添加产品</el-button>-->
<!--                    </el-form-item>-->
                    <el-form-item>
                        <el-button type="warning" @click="addAllColdProducts">添加全部冷链商品</el-button>
                        <el-button type="warning" @click="addAllNomalProducts">添加全部常温商品</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="productName" label="产品名称"></el-table-column>
                    <el-table-column prop="groupName" label="分组名称"></el-table-column>
                    <el-table-column prop="groupType" :formatter="convertStatus12" label="分组类型"></el-table-column>
                    <el-table-column prop="sort" label="排序">
<!--                      <el-input-number v-model="sort" :min="0" :max="9999"></el-input-number>-->
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.sort" :min="0" :max="99"  @change="saveFullProductSort(scope.row)" ></el-input-number>
                      </template>

                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="160">
                        <template slot="header" slot-scope="scope">
                            操作
                            <el-button style="margin-left: 10px" type="danger" size="mini" @click="delAllProducts">
                                删除所有
                            </el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button plain size="small" type="danger" icon="el-icon-delete" circle
                                       @click="deleteMallFullcutDetail(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange1"
                            @current-change="handleCurrentChange1"
                            :current-page="formInline.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline.recordsTotal">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getFullCutDetail,
        saveOrUpdateFullCutList,
        getFullCutDetailList,
        saveMallFullcutDetail,
        deleteMallFullcutDetail,
        getActiveListL,
        getGroupListL,
        getProductListL,
        addFullCutAllColdProducts,
        addFullCutAllNomalProducts,
        delFullCutAllProducts,
      saveFullProductSort
    } from '../../api/api';
    //定义组件
    export default {
        data() {
            return {
                fullcutId: this.$route.params.id,
                tabSel: 'tab0',
                dataList: [],
                getActiveList: [],
                getGroupList: [],
                getProductList: [],

                statusList: [{value: 1, name: '有效'}, {value: 0, name: '无效'}],
                statusList1: [{value: 1, name: '是'}, {value: 0, name: '否'}],
                typeList: [{value: 1, name: '按数量减'}, {value: 2, name: '按金额减'},{value: 3, name: '按金额和数量减'},{value: 4, name: '按数量打折'},{value: 5, name: '按金额打折'}],
                productRuleList: [{value: 1, name: '赠送'}, {value: 2, name: '直减'}],
                selArr:[{label:'否',value:0},{label:'是',value:1}],
                ruleList: [{value: 1, name: '按最大金额金额减'}, {value: 2, name: '按最小金额减'}, {value: 3, name: '随机减'}, {
                    value: 4,
                    name: '指定商品'
                }, {
                    value: 5,
                    name: '指定数量和金额减'
                }, {
                    value: 6,
                    name: '打折'
                }],
                fullClassList: [{value: 0, name: '满减活动'}, {value: 1, name: '全局满减'}],
                loading: true,
                cut_type_desc:'减',
                loading1: true,
                formInline: {
                    fullcutId: this.$route.params.id,
                    currentPage: 1,
                    pageSize: 40,
                    recordsTotal: 0,
                },
                form: {
                    fullCutId: "",
                    fullCutName: "",
                    beginTime: "",
                    endTime: "",
                    type: "",
                    fullNumber: "",
                    cutNumber: "",
                    cutRule: 0,
                    cutRuleName: "",
                    limitCount: "",
                    status: "",
                    doublePromotion: "",
                    doubleFreeGift: "",
                    enableUseCoupon: "",
                    fullCutTitle: "",
                    productIdsForm: [],
                    productNames: "",
                    productRule: "",
                    activeNo: '',
                    fullClass: 0,
                    fullAmout:0,
                    isFreeFreight:0,
                    fullCutNumbersForm: []
                },
                fullCutNumbersStr: "",
                form1: {
                    fullCutId: this.$route.params.id,
                    productId: [],
                    groupId: [],
                },
                amountDisabled: false,
                globalFullCutDisabled: false,
                typeDisabled: false
            }
        },
        //挂载时候执行
        mounted() {
            if (this.fullcutId != 0) {
                this.initFullDetail()
                this.getFullCutDetailList()
            }
            getGroupListL().then((res) => {
                this.getGroupList = res.data.value;
            });
            getProductListL().then((res) => {
                this.getProductList = res.data.value;
            })
        },
        methods: {
            initFullDetail(){
                getFullCutDetail({fullcutId: this.fullcutId}).then(res => {
                    console.log(res)
                    this.form = res.data.value
                    this.form.fullCutNumbersForm = (this.form.fullCutNumbers == '' ? [] : JSON.parse(this.form.fullCutNumbers));
                })
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateFullCutList(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        if (this.fullcutId == 0) {
                            this.formInline.fullcutId = res.data.value
                            this.fullcutId = res.data.value
                            this.form1.fullCutId=this.fullcutId
                            console.log('满减id:'+this.fullcutId);
                        }
                        this.tabSel = 'tab1'
                        // this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            addAllColdProducts(){
                this.loading = true;
                addFullCutAllColdProducts({"fullCutId": this.fullcutId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '添加成功',
                            type: 'success'
                        });
                        this.getFullCutDetailList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            addAllNomalProducts(){
                this.loading = true;
                console.log('fullid', this.fullcutId)
                addFullCutAllNomalProducts({"fullCutId": this.fullcutId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '添加成功',
                            type: 'success'
                        });
                        this.getFullCutDetailList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            delAllProducts(){
                this.loading = true;
                this.$confirm('删除产品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center: true,
                    type: 'warning'
                }).then(() => {
                    delFullCutAllProducts({"fullCutId": this.fullcutId}).then((res) => {
                        this.loading = false;
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '添加成功',
                                type: 'success'
                            });
                            this.getFullCutDetailList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        showClose: true,
                        message: '取消删除',
                        type: 'error'
                    });
                })
            },
            getFullCutDetailList() {
                this.loading1 = true;
                getFullCutDetailList(this.formInline).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.formInline.pageSize = val;
                this.getFullCutDetailList()
            },
            handleCurrentChange1(val) {
                this.formInline.currentPage = val;
                this.getFullCutDetailList()
            },
            convertStatus12(row, column, cellValue) {
                if (cellValue == 2) {
                    return "分组";
                } else {
                    return "单品";
                }
            },
            deleteMallFullcutDetail(row) {
                this.$confirm('删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteMallFullcutDetail({fullCutDetailId: row.fullCutDetailId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getFullCutDetailList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            handleAddProductGroup() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveMallFullcutDetail(this.form1).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getFullCutDetailList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            typeChange(){
                this.typeDisabled = false;
                this.amountDisabled = false;
                this.cut_type_desc='减';
                if (this.form.type == 2) {//按金额
                    this.typeDisabled = false;
                    this.amountDisabled = true;
                    if (this.form.cutRule == 4) {
                        this.form.cutRule = 1;
                    }
                    if (this.ruleList.length == 4){
                        this.ruleList.splice(3, 1);
                    }
                } else  if (this.form.type == 1) {
                    //按数量
                    this.typeDisabled = false;
                    this.amountDisabled = false;
                    if (this.ruleList.length == 3){
                        this.ruleList.push({value: 4, name: '指定商品'});
                    }
                }else if (this.form.type == 3) {
                    //指定数量和金额
                    this.amountDisabled = true;
                    this.typeDisabled = false;
                    this.form.fullClass=0
                    this.form.cutRule=5
                }else if (this.form.type == 4) {
                    //指定数量折扣
                    this.typeDisabled = false;
                    this.amountDisabled = false;
                    this.cut_type_desc='打';
                    if (this.ruleList.length == 3){
                        this.ruleList.push({value: 4, name: '指定商品'});
                    }
                }else if (this.form.type == 5) {
                    //指定金额折扣
                    this.typeDisabled = false;
                    this.amountDisabled = false;
                    this.cut_type_desc='打';
                    if (this.ruleList.length == 3){
                        this.ruleList.push({value: 4, name: '指定商品'});
                    }
                }
                this.cutRuleChange();
            },
            fullClassChange(){
                if (this.form.fullClass == 1) {//全局减
                    this.globalFullCutDisabled = true;
                    this.form.type = 2;
                    this.typeChange();
                } else {
                    this.globalFullCutDisabled = false;
                }
            },
            cutRuleChange(){
                if (this.form.cutRule == 4) {
                    this.amountDisabled = false;
                } else {
                    this.amountDisabled = true;
                }
            },
            addFullCutNumbers(){
                console.log(this.form.fullCutNumbersForm);
                var str = "";
                for (var i = 0; i < this.form.fullCutNumbersForm.length; i++) {
                    if (this.form.fullCutNumbersForm[i].fullNumber == this.form.fullNumber) {
                        this.$message({
                            showClose: true,
                            message: '已经存在',
                            type: 'fail'
                        });
                        return;
                    }
                    if (i == 0) {
                        str += "满" + this.form.fullCutNumbersForm[i].fullNumber + this.cut_type_desc + this.form.fullCutNumbersForm[i].cutNumber+(this.form.type==4||this.form.type==5?'折':'');
                    } else {
                        str += "；满" + this.form.fullCutNumbersForm[i].fullNumber + this.cut_type_desc  + this.form.fullCutNumbersForm[i].cutNumber+(this.form.type==4||this.form.type==5?'折':'');
                    }
                }
                this.form.fullCutNumbersForm.push({
                    "fullNumber": this.form.fullNumber,
                    "cutNumber": this.form.cutNumber
                });
                if (str == "") {
                    str += "满" + this.form.fullNumber + this.cut_type_desc  + this.form.cutNumber+(this.form.type==4||this.form.type==5?'折':'');
                } else {
                    str += "；满" + this.form.fullNumber + this.cut_type_desc  + this.form.cutNumber+(this.form.type==4||this.form.type==5?'折':'');
                }

                this.fullCutNumbersStr = str;
            },
            delFullCutNumbers(){
                console.log({"fullNumber": this.form.fullNumber, "cutNumber": this.form.cutNumber});
                if (this.form.fullCutNumbersForm.length > 0) {
                    this.form.fullCutNumbersForm.splice(this.form.fullCutNumbersForm.length - 1, 1);
                    this.fullCutNumbersStr = this.convertFullCutStr();
                }
            },
            convertFullCutStr(fullcut){
                if (fullcut == undefined) {
                    fullcut = this.form.fullCutNumbersForm;
                }
                var str = "";
                if (fullcut.length > 0) {
                    for (var i = 0; i < fullcut.length; i++) {
                        if (i == 0) {
                            str += "满" + fullcut[i].fullNumber + "减" + fullcut[i].cutNumber;
                        } else {
                            str += "；满" + fullcut[i].fullNumber + "减" + fullcut[i].cutNumber;
                        }
                    }
                }
                return str;
            },
            handleClick(){
                console.log(this.tabSel)
            },
            returnHistory(){
                window.history.back()
            },
          saveFullProductSort(row){
            saveFullProductSort(row).then((res) => {
              if (res.data.status == 200) {
                this.getFullCutDetailList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                });
              }
            })
          },
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .full-cut-detail-wrap {
        padding: 10px;
        .header-return {
            margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
            position: relative;
            h2 {
                text-align: center;
                position: absolute;
                left: 50%;
                top: 0;
                margin: 0;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/sales/fullcutDetail.vue